const MarketplaceProvisioning = {
  mounted() {
    this.poll = () => {
      const target = this.el.dataset.target
      if (target) this.pushEventTo(target, "refresh_activation", {})
    }

    this.timer = window.setInterval(this.poll, 900)
  },

  destroyed() {
    if (this.timer) window.clearInterval(this.timer)
  }
}

export default MarketplaceProvisioning
